import React from "react";
import {isMobile} from "../../helpers/ApplicationHelper";
import cookie from "react-cookie";
import PopupInPersonAptTips from "../popups/popupInPersonAptTips";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {hideTips} from "../../actions/tips";
import PropTypes from "prop-types";

class Tip extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            show:  cookie.load('ll_hide_tips') !== 'true'
        };
    }

    closeTip(){
        this.props.hideTips();
    }
    render() {
        return (
            this.props.showTips && (
                <div className={isMobile() ? 'tip mobile' : 'tip'}>
                    <div className="tip-close" onClick={()=>{
                        this.closeTip();
                    }}></div>
                    <h5>Meet With An Expert!</h5>
                    <span>{this.props.children}</span>
                    <div className="learn-more">
                        <a href="#"
                           onClick={(e)=>{
                               e.preventDefault();
                               PopupInPersonAptTips.initPopup({
                                   popupClassName: 'popup-tip',
                                   showSchedulePickup: this.props.showSchedulePickup
                               });
                               this.closeTip();
                           }}
                        >
                            Learn more
                        </a>
                    </div>
                </div>
            )
        )
    }
}

Tip.propTypes = {
    showSchedulePickup: PropTypes.bool,
    children: PropTypes.node,
    showTips: PropTypes.func,
    hideTips: PropTypes.func,
}

const mapStateToProps = ({ Tips }) => {
    return {
        showTips: Tips.showTips,
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ hideTips }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Tip);
